import { fetchToken, getToken } from './auth-service';
import api from '../endeavor-api';
import {
    ENDEAVOR_AUTH,
    REACT_APP_ENDEAVOR_REALM,
    REACT_APP_ENDEAVOR_X_API_KEY
} from '../constants/api-constants';
import { deleteFromSessionStorage, setSessionStorageItem } from '../../../utils';

export const getVideosByTags = async ({ callbackUrl }) => {
    let authToken = await getToken();
    let videosByTags = await fetchData({
        authToken,
        callbackUrl,
    });
    if (videosByTags.error && videosByTags.error.value.response.status === 401) {
        authToken = await fetchToken();
        videosByTags = await fetchData({
            authToken,
            callbackUrl,
        });

        deleteFromSessionStorage(ENDEAVOR_AUTH);
        setSessionStorageItem(ENDEAVOR_AUTH, authToken);
    }

    if (videosByTags.error) {
        return {
            error: videosByTags.error,
        };
    }
    return videosByTags;
};

const fetchData = async ({ authToken, callbackUrl, params }) => {
    try {
        const response = await api.get(callbackUrl, {
            params,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${authToken}`,
                'x-api-key': REACT_APP_ENDEAVOR_X_API_KEY,
                Realm: REACT_APP_ENDEAVOR_REALM,
            },
        });

        return response.data;
    } catch (error) {
        return {
            error: {
                isEmpty: false,
                value: error,
                statusCode: error.response ? error.response.status : null
            },
        };
    }
};
